import { createPortal } from "react-dom";
import { FileSpreadsheet, X } from "lucide-react";

import PipelineImportPanel from "./PipelineImportPanel";

export default function EditPipelineSheetDrawer({ pipeline, isOpen, onClose, onUpdated }) {
  if (!pipeline) return null;

  return createPortal(
    <>
      <div
        className={`fixed inset-0 z-[9998] bg-[#071321]/35 backdrop-blur-sm transition-opacity duration-300 ${isOpen ? "pointer-events-auto opacity-100" : "pointer-events-none opacity-0"}`}
        onClick={onClose}
      />
      <aside className={`fixed right-0 top-0 z-[9999] h-screen w-full max-w-5xl bg-white shadow-2xl transition-transform duration-300 ease-out ${isOpen ? "translate-x-0" : "translate-x-full"}`}>
        <div className="flex h-full flex-col">
          <header className="flex items-center justify-between border-b border-[#dcebf3] bg-white px-6 py-5 sm:px-8">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-[#e5f5fc] text-[#147db5]"><FileSpreadsheet className="h-5 w-5" /></span>
              <div><p className="text-xs font-bold uppercase tracking-[0.14em] text-[#1689c1]">Spreadsheet editor</p><h2 className="mt-0.5 text-lg font-bold text-[#102f44]">Edit pipeline with Google Sheets</h2></div>
            </div>
            <button type="button" onClick={onClose} aria-label="Close pipeline sheet editor" className="rounded-xl p-2 text-[#7892a4] transition hover:bg-[#edf5f8] hover:text-[#294d63]"><X className="h-5 w-5" /></button>
          </header>
          <PipelineImportPanel
            mode="edit"
            pipeline={pipeline}
            onChange={() => {}}
            onCancel={onClose}
            onImported={onUpdated}
          />
        </div>
      </aside>
    </>,
    document.body
  );
}
